import React from "react";

import styles from "./primaryButton.module.scss";

type Props = {
  label: string;
  disabled: boolean;
  type?: "submit" | "reset" | "button" | undefined;
} & React.HTMLAttributes<HTMLButtonElement>;

export default function PrimaryButton({
  label,
  disabled,
  type,
  ...restProps
}: Props) {
  return (
    <button
      className={styles.primaryButton}
      disabled={disabled}
      type={type}
      {...restProps}
    >
      {label}
    </button>
  );
}
